export default "__VITE_ASSET__DAX4HhS3__"